document.addEventListener("turbolinks:load", function() {
  if( document.getElementById('google_play_button') || document.getElementById('appstore_button')){
    set_appstore_buttons(check_for_mobile());
  }
  if (document.getElementById("qr_code_div")) {
    // set_qr_code_div()
  }
})

function set_appstore_buttons(isMobile){
  if(isMobile != false){
    if(isMobile.Android()){
      document.getElementById('google_play_button').style.display = 'inline';
    } else if (isMobile.iOS()) {
      document.getElementById('appstore_button').style.display = 'inline';
    }
  }
}

function check_for_mobile(){
  var isMobile = {
    Android: function() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
        return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
    },
    any: function() {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
  };
  if( isMobile.any() ){
    return isMobile;
  }else {
    return false;
  }
}

function set_qr_code_div(){
  if( check_for_mobile() == false){
    document.getElementById("qr_code_div").style.display = 'block';
  } else {
    document.getElementById("qr_code_div").style.display = 'none';
  }
}
